// src/components/panelLogin/AccountData.js

/**
 * Lista przykładowych kont użytkowników (2x Admin, 8x Client).
 * Te konta są "wbudowane" w projekt.
 */
const accountData = [
  {
    id: 1,
    email: "admin1@example.com",
    password: "admin123",
    role: "Admin",
  },
  {
    id: 2,
    email: "admin2@example.com",
    password: "secret777",
    role: "Admin",
  },
  {
    id: 3,
    email: "user1@example.com",
    password: "user1pass",
    role: "Client",
  },
  {
    id: 4,
    email: "user2@example.com",
    password: "user2pass",
    role: "Client",
  },
  {
    id: 5,
    email: "user3@example.com",
    password: "user3pass",
    role: "Client",
  },
  {
    id: 6,
    email: "user4@example.com",
    password: "user4pass",
    role: "Client",
  },
  {
    id: 7,
    email: "user5@example.com",
    password: "user5pass",
    role: "Client",
  },
  {
    id: 8,
    email: "user6@example.com",
    password: "user6pass",
    role: "Client",
  },
  {
    id: 9,
    email: "user7@example.com",
    password: "user7pass",
    role: "Client",
  },
  {
    id: 10,
    email: "user8@example.com",
    password: "user8pass",
    role: "Client",
  },
];

export default accountData;
